import { GetWrapper, PostWrapper } from "../../../axios";
import { IContactPerson, INewContactPerson } from "../../../models";

export const getClients = () => GetWrapper<Array<IContactPerson>>("/ContactPerson");

export const postNewClient = (data: INewContactPerson) => PostWrapper<null>("/ContactPerson", data);
